import { render, staticRenderFns } from "./DescriptionAndAmenities.vue?vue&type=template&id=2a45353d&scoped=true&"
import script from "./DescriptionAndAmenities.vue?vue&type=script&lang=js&"
export * from "./DescriptionAndAmenities.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionAndAmenities.vue?vue&type=style&index=0&id=2a45353d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45353d",
  null
  
)

export default component.exports